import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(r3, r4) {
  var result = Complex.createComplex((-1 * r3) / (r3 + r4), 0);
  return result;
}

export function computeComplexFF(complexRParallel, r3, r4) {
  var result = complexRParallel.divide(Complex.createComplex(r3 + r4, 0));
  return result;
}
